import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./itemPrint.data.form";
import InputText from "../../../utils/InputText";
import InputDate from "../../../utils/InputDate";
import InputSelect from "../../../utils/InputSelect";

const ItemPrintForm = (props) => {
  const { t } = useTranslation();
  const { handleSubmit, onBack, onSave, items } = props;

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <h3 className="title">{t("forms.items.printTag")}</h3>
        </div>
      </div>
      <div className="row justify-content-center mt-3">
        <div className="col-12 col-md-11">
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-12">
                <Field
                  id="itemCode"
                  name="itemCode"
                  labelField={t("forms.items.labels.itemCode")}
                  component={InputSelect}
                  placeholder=""
                  optionLabel="name"
                  optionValue="code"
                  options={items}
                  addOptionEmpty
                  classNamePrefix="dark"
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-4">
                <Field
                  id="date"
                  className="form-control"
                  labelField={t("forms.items.labels.date")}
                  name="date"
                  placeholder=""
                  component={InputDate}
                  language="es"
                  dateFormat="dd-MM-yyyy"
                  mandatory
                  defaultHours={0}
                  defaultMinutes={0}
                />
              </div>
              <div className="col-4">
                <Field
                  id="dateProd"
                  className="form-control"
                  labelField={t("forms.items.labels.dateProd")}
                  name="dateProd"
                  placeholder=""
                  component={InputDate}
                  language="es"
                  dateFormat="dd-MM-yyyy"
                  mandatory
                  defaultHours={0}
                  defaultMinutes={0}
                />
              </div>
              <div className="col-4">
                <Field
                  id="dateExp"
                  className="form-control"
                  labelField={t("forms.items.labels.dateExp")}
                  name="dateExp"
                  placeholder=""
                  component={InputDate}
                  language="es"
                  dateFormat="dd-MM-yyyy"
                  mandatory
                  defaultHours={0}
                  defaultMinutes={0}
                />
              </div>
            </div>

            <div className="row mt-2">
              <div className="col-6">
                <Field
                  id="harvestYear"
                  className="form-control"
                  labelField={t("forms.items.labels.harvestYear")}
                  name="harvestYear"
                  component={InputText}
                  fieldType="number"
                  placeholder=""
                  mandatory
                />
              </div>
              <div className="col-6">
                <Field
                  id="weight"
                  className="form-control"
                  labelField={t("forms.items.labels.weight")}
                  name="weight"
                  component={InputText}
                  fieldType="number"
                  placeholder=""
                  mandatory
                />
              </div>
              <div className="col-6">
                <Field
                  id="copies"
                  className="form-control"
                  labelField={t("forms.items.labels.copies")}
                  name="copies"
                  component={InputText}
                  fieldType="number"
                  placeholder=""
                  mandatory
                />
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-10 col-sm-11 text-center mt-5 mb-3">
                <button
                  type="button"
                  onClick={() => onBack()}
                  className="btn btn-md btn-secondary me-2"
                >
                  {t("forms.items.buttons.cancel")}
                </button>

                <button type="submit" className="btn btn-md btn-primary">
                  {t("forms.items.buttons.print")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

ItemPrintForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  onBack: PropTypes.func,
  onSave: PropTypes.func,
};

const ItemPrintFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: (props) => {
    return validationDataModel(props.edit);
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "ItemPrintForm",
})(ItemPrintForm);

export default ItemPrintFormF;
